export default "__VITE_ASSET__LG$5OALu__"